/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import { Table, Spin } from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { deleteProduct, fetchProductsData, setLoading } from '../../redux/products/productsActions';
import { productsColumnData } from './productsTableData';

const ProductTable = () => {
    // Accessing the product data State Store
    const products = useSelector((state) => [
        state.products.productsData,
        state.products.productsTotalPages,
        state.products.productsSummary,
        state.products.loading,
    ]);

    // Accessing the product dispatch Method
    const dispatch = useDispatch();

    // Get Current URL Path
    const { search } = useLocation();
    const { path } = useRouteMatch();
    const history = useHistory();

    const isQueryParamExist = (data) => {
        const newURL = queryString.stringifyUrl({
            url: path + search,
            query: { page: data.selected + 1 },
        });
        history.push(newURL);
    };

    // Fetching data during Initialization & if the search parameter changes
    useEffect(() => {
        dispatch(fetchProductsData(search));
        dispatch(setLoading());
    }, [dispatch, search]);

    // Selection Section

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const hasRowKeys = selectedRowKeys.length > 0;
    // console.log(hasRowKeys);
    const onSelectChange = (keys) => {
        setSelectedRowKeys(keys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const customSelectAll = () => {
        if (selectedRowKeys.length === products[0].length) {
            setSelectedRowKeys([]);
            console.log('if');
        }
    };
    // console.log(allKey);
    const deleteMultiple = async (selectedRows) => {
        await dispatch(deleteProduct(selectedRows));
        if (selectedRowKeys.length === products[0].length) {
            setSelectedRowKeys([]);
        }
        setSelectedRowKeys([]);
        console.log(selectedRows, selectedRowKeys);
    };

    const customTableHeader = () => (
        <div className="flex justify-between items-center">
            <div>
                <Checkbox
                    onChange={() => customSelectAll()}
                    indeterminate={selectedRowKeys.length < products[0].length}
                    checked={selectedRowKeys}
                />
                <button
                    className="px-25px text-primary text-base font-semibold focus:outline-none"
                    type="button"
                    // eslint-disable-next-line no-alert
                    onClick={() => deleteMultiple(selectedRowKeys)}
                >
                    Delete Permanently
                </button>
                {/* <button
                    className="px-25px text-primary text-base font-semibold focus:outline-none"
                    type="button"
                    // eslint-disable-next-line no-alert
                    onClick={() => alert(`${selectedRowKeys} Made Duplicate`)}
                >
                    Make Duplicate
                </button> */}
                {/* <button
                    className="px-25px text-primary text-base font-semibold focus:outline-none"
                    type="button" // eslint-disable-next-line no-alert
                    onClick={() => alert(`${selectedRowKeys} Made Online`)}
                >
                    Make Online
                </button> */}
                {/* <button
                    className="px-25px text-primary text-base font-semibold focus:outline-none"
                    type="button"
                    // eslint-disable-next-line no-alert
                    onClick={() => alert(`${selectedRowKeys} Made Draft`)}
                >
                    Make Draft
                </button> */}

                {/* <button
                    className="px-25px text-primary text-base font-semibold focus:outline-none"
                    type="button"
                    // eslint-disable-next-line no-alert
                    onClick={() => alert(`${selectedRowKeys} Made to Edit`)}
                >
                    More Edit
                </button> */}
            </div>
            <button
                className="text-red text-base font-semibold"
                type="button"
                onClick={() => setSelectedRowKeys([])}
            >
                Cancel Selection
            </button>
        </div>
    );

    return (
        <>
            <Spin tip="loading....." spinning={products[3]}>
                <Table
                    rowSelection={rowSelection}
                    rowKey={(record) => record.id}
                    title={hasRowKeys ? () => customTableHeader() : null}
                    showHeader={!hasRowKeys && true}
                    dataSource={products[0]}
                    columns={productsColumnData}
                    pagination={false}
                    size="medium"
                    className="dokan-table"
                    rowClassName="dokan-row"
                    // onSelectAll={(a, b, c) => onSelectAll(a, b, c)}
                    // selections
                />
                <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={products[1]}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={isQueryParamExist}
                    containerClassName="dokan-pagination-container"
                    subContainerClassName="dokan-pagination-li"
                    activeClassName="dokan-pagination-active"
                />
            </Spin>
        </>
    );
};

export default ProductTable;
